<template>
  <div class="checkbox">
    <div class="checkbox-container" :class="{ disabled: $attrs.disabled }">
      <input
        v-bind="$attrs"
        :checked="value"
        :class="{ burger: burgerMenu }"
        class="checkbox-container__checkbox"
        type="checkbox"
        @change="change"
      />
      <label v-if="label" class="label" @click="change">
        {{ label }}
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    burgerMenu: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      checked: this.value
    }
  },

  methods: {
    change() {
      this.checked = !this.checked
      this.$emit('input', this.checked)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/base/base_checkbox.scss';
</style>



// WEBPACK FOOTER //
// src/components/base/BaseCheckbox.vue